import React from "react";

/**
 * @component CircleMultipleIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <CircleMultipleIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CircleMultipleIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="CircleMultipleIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M19.657 8.343A8 8 0 118.343 19.657 8 8 0 0119.657 8.343zm-9.9 1.414a6 6 0 108.486 8.486 6 6 0 00-8.486-8.486zM10 2a7.97 7.97 0 015.291 2H10a6 6 0 00-5.996 5.775L4 10v5.291A8 8 0 0110 2z"
        fillRule="evenodd"
      />
    </svg>
  )
);
CircleMultipleIcon.displayName = "CircleMultipleIcon";
export default CircleMultipleIcon;
